// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"1d2a52e2","396":"ec2db396"}[chunkId] + ".chunk.js";
};